let pageConfig = {};

// 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '储能充放电记录'
    },
];

// 列表展示项
pageConfig.listColumns = [
    {
        label: '储能订单号',
        props: '',
        minWidth: 240,
    },
    {
        label: '开始时间',
        props: '',
        minWidth: 200,
    },
    {
        label: '结束时间',
        props: '',
        minWidth: 200,
    },
    {
        label: 'ZD-BOX编号',
        props: '',
        minWidth: 200,
    },
    {
        label: '充放类型',
        props: '',
        minWidth: 200,
    },
    {
        label: '充放度数',
        props: '',
        minWidth: 120,
    },
    {
        label: '储能开始SOC',
        props: '',
        minWidth: 180,
    },
    {
        label: '储能结束SOC',
        props: '',
        minWidth: 240,
    },
    {
        label: '车辆开始SOC',
        props: '',
        minWidth: 160,
    },
    {
        label: '车辆结束SOC',
        props: '',
        minWidth: 240,
    },
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
};

export default pageConfig;
